import { OnboardingStatus } from 'modules/onboarding/common/components';
import { useKycOnboardingStatus } from 'modules/onboarding/common/hooks';

import { useKyc } from '../hooks';
import { LegalFirstHeadView } from '../views';

interface Props {
  clientId: string;
}

export const LegalFirstHeadContainer = ({ clientId }: Props) => {
  const { expirationHandler, loading, token, status } = useKyc(clientId);

  const onboardingStatus = useKycOnboardingStatus(status);

  if (onboardingStatus) {
    return <OnboardingStatus onboardingStatus={onboardingStatus} />;
  }

  return (
    <LegalFirstHeadView
      expirationHandler={expirationHandler}
      loading={loading}
      token={token}
    />
  );
};
